// directives/capitalize.js
export default {
  mounted(el, binding) {
    const input = el.querySelector('input');
    if (!input) return;

    // Skip for email and phone types
    const type = input.type?.toLowerCase();
    if (type === 'email' || type === 'tel' || type === 'phone') {
      return;
    }
    console.log(input.name);
    // Options: capitalize first letter of entire string (default) or each word
    let options = binding.value || { mode: 'first-letter' };
    if (input.name == 'nino') {
      options = { mode: 'each' };
    }

    const capitalize = (value) => {
      if (!value || value.length === 0) return value;
      console.log('options', options);
      if (options.mode === 'each-word') {
        // Capitalize first letter of each word
        return value.replace(/\b\w/g, (char) => char.toUpperCase());
      } else if (options.mode === 'each') {
        return value.toUpperCase();
      } else {
        // Capitalize only first letter of entire string
        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    };

    const handleInput = (event) => {
      const target = event.target;
      const cursorPos = target.selectionStart;
      const value = target.value;
      console.log('value ', value);
      const capitalized = capitalize(value);
      console.log('value ', value, capitalized);
      if (value !== capitalized) {
        target.value = capitalized;
        target.dispatchEvent(new Event('input', { bubbles: true }));

        // Adjust cursor position for each-word mode
        if (options.mode === 'each-word') {
          // Simple cursor restoration
          target.setSelectionRange(cursorPos, cursorPos);
        } else {
          target.setSelectionRange(cursorPos, cursorPos);
        }
      }
    };

    input.addEventListener('input', handleInput);

    el._capitalizeCleanup = () => {
      input.removeEventListener('input', handleInput);
    };
  },

  unmounted(el) {
    if (el._capitalizeCleanup) {
      el._capitalizeCleanup();
    }
  }
};
